<template lang="pug">
b-modal#approveTicketFcp(
  ref="approveTicketFcp"
  :title='$t("ui.combine.approve_fcp_ticket")'
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th(colspan="2")
              span {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.account_id") }}
            td
              span {{ ticketDetail.account_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:title="$n(ticketDetail.amount, 'currency')" :class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
            td
              span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
            td
              span {{ ticketDetail.target_bank_acc_remark }}
          tr(v-if="['AUD'].includes(getCurrencyCode)")
            td
              span {{ $t("ui.payid") }}
            td
              span {{ ticketDetail.target_bank_acc_remark_2 }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}
          
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    b-form-group(:label="$t('ui.sender_bank')").mb-0
      BankListAutoWithdrawal(
        ref="senderBank"
        size="sm"
        type="array"
        :dirty="$v.sender_bank.$dirty"
        :error="$v.sender_bank.$error"
        v-model.trim.lazy="$v.sender_bank.$model"
        :disabled="loading"
        :operatorID="parentId"
        :externalID="ticketDetail.external_id"
        @min-limit-updated="handleMinLimitUpdated"
        @min-limit-changed="handleMinLimitChanged"
      )
      ValidateResult(:value="$v.sender_bank" :name="$t('ui.sender_bank')")
      small.text-info.ml-2(v-if="minLimit != null") {{ $t("ui.min_withdrawal") }}: {{ minLimit }}
    b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
      DebounceInput(
        size="sm"
        type="text"
        v-model="remark"
        :disabled="loading"
      )
    div(slot="modal-footer")
      SubmitButton.float-right(icon="fa fa-check" :text="$t('ui.approve')" @click="approveTicket()" size="sm" variant="success" v-if="showApproveBtn()" :loading="loading")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary" :loading="loading").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import BankListAutoWithdrawal from "@/library/BankListFreeAutoWithdrawal";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankListAutoWithdrawal,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    },
    parentId:{
      type: String,
      default: ""
    },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      memberDetail: null,
      sender_bank: '',
      remark: '',
      minLimit: null,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    sender_bank: {
      required
    },
  },
  methods: {
    showApproveBtn() {
      if (['AUDIT'].includes(this.ticketDetail.status.trim().toUpperCase()))
        return true;
      else
        return false;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.sender_bank = '';
      this.remark = '';
      this.minLimit = null;
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailFreeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    approveTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // Check if exchanged_amount is less than minLimit
        if (this.ticketDetail && this.ticketDetail.exchange_currency != null && 
            this.ticketDetail.exchanged_amount != null && this.minLimit != null) {
          const exchangedAmount = parseFloat(this.ticketDetail.exchanged_amount);
          const minLimitValue = parseFloat(this.minLimit);
          
          if (!isNaN(exchangedAmount) && !isNaN(minLimitValue) && exchangedAmount < minLimitValue) {
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.minWithdrawalNotMet"), "error");
            return;
          }
        }
        this.confirmApproveTicket();
      }
    },
    confirmApproveTicket: function() {
      let url = '';
      var payment_mode = this.sender_bank.split(' - ')[1].trim();

      if (["GSPAY","LUXEPAY","LUXEPAYQR","FPAY","FPAYQR","AMOPAY","METAPAY","DGPAYQR","SECRETPAYQRMY",
           "VADERPAY","VADERPAYQR","PEPAY","NOVAPAY","PEPAYPIN","GSPAYQR"].includes(payment_mode)) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.notSupportedWithdrawalPG"), "error");
        return;
      }

      switch(payment_mode) {
        //argentina
        case "MGMPAY":
          url = config.withdrawalMGMPayFcUrl();
          break;
        case "ROCKETX":
          url = config.withdrawalROCKETXArsFcUrl();
          break;
        //russia
        case "INPAY":
          url = config.withdrawalINPayFcUrl();
          break;
        case "ONEPAY":
          url = config.withdrawalONEPayFcUrl();
          break;
        //argentina && russia
        case "HIGHHELP":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalHIGHHELPArsFcUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalHIGHHELPRubFcUrl();
          }
          break;
        case "MERCURIO":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalMERCURIOArsFcUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalMERCURIORubFcUrl();
          }
          break;
        case "JUPITER":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalJUPITERArsFcUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalJUPITERRubFcUrl();
          }
          break;
        case "PROPAYLLER":
          if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalPROPAYLLERRubFcUrl();
          }
          break;
        case "AMPAY":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalAMPayArsFcUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalAMPayRubFcUrl();
          }
          break;
        case "NIRVANA":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalNIRVANAArsFcUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalNIRVANARubFcUrl();
          } else if (this.getCurrencyCode == "AUD") {
            url = config.withdrawalNIRVANARubFcUrl();
          }
          break;
        //malaysia
        case "DGPAY":
          url = config.withdrawalDGPayFcUrl();
          break;
        case "TRUEPAY":
          url = config.withdrawalTRUEPayFcUrl();
          break;
        case "ONEPAYMY":
          url = config.withdrawalONEPayMYFcUrl();
          break;
        case "TRUSTPAY":
          url = config.withdrawalTRUSTPayFcUrl();
          break;
        case "EPICPAY":
          url = config.withdrawalEPICPayFcUrl();
          break;
        case "SECUREPAY":
          url = config.withdrawalSECUREPayFcUrl();
          break;
        case "JPAY":
          url = config.withdrawalJPayFcUrl();
          break;
        case "TTPAY":
          url = config.withdrawalTTPayFcUrl();
          break;
        case "AUTOPAY":
          url = config.withdrawalAUTOPayFcUrl();
          break;
        case "SECRETPAYMY":
          url = config.withdrawalSECRETPayMYFcUrl();
          break;
        case "VPAY":
          url = config.withdrawalVPayFcUrl();
          break;
        case "DIREPAY":
          url = config.withdrawalDIREPayFcUrl();
          break;
        //vietnam
        case "YESPAY":
          url = config.withdrawalYESPayFcUrl();
          break;
        case "BESTPAY":
          url = config.withdrawalBESTPayFcUrl();
          break;
        case "TIMEPAY":
          url = config.withdrawalTIMEPayFcUrl();
          break;
        case "DAYANGPAY":
          url = config.withdrawalDAYANGPayFcUrl();
          break;
        case "ONEVNPAY":
          url = config.withdrawalONEVNPayFcUrl();
          break;
        case "CLUBSPAY":
          url = config.withdrawalCLUBSPayFcUrl();
          break;
        case "SECRETPAY":
          url = config.withdrawalSECRETPayFcUrl();
          break;
        case "WOWPAY":
          url = config.withdrawalWOWPayFcUrl();
          break;
        case "UBIT":
          url = config.withdrawalUBITFcUrl();
          break;
        case "GLOBALPAY":
          url = config.withdrawalGLOBALPayFcUrl();
          break;
        case "BCATPAYVN":
          url = config.withdrawalBCATPayVNFcUrl();
          break;
        case "SOLIDPAY":
          url = config.withdrawalSOLIDPayFcUrl();
          break;
        case "KPAYVN":
          url = config.withdrawalKPayVNFcUrl();
          break;
        //bangladesh
        case "TIGERPAY":
          url = config.withdrawalTIGERPayFcUrl();
          break;
        case "TAKAPAY":
          url = config.withdrawalTAKAPayFcUrl();
          break;
        case "BCATPAY":
          url = config.withdrawalBCATPayFcUrl();
          break;
      }

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
        audit_by: this.$store.getters.loginId,
      };

      json.target_bank_id = this.ticketDetail.recipient_bank_id;
      json.ref_no = this.ticketDetail.ref_no;
      // json.sender_bank_id = this.sender_bank.split(' - ')[0].trim();
      json.payment_mode = this.sender_bank.split(' - ')[1].trim();
      json.amount = this.ticketDetail.amount;
      json.target_bank_acc_holder = this.ticketDetail.recipient_bank_acc_holder;

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.approveTicketFcp.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.approveTicketFcp.hide();
    },
    handleMinLimitUpdated: function(data) {
      // Store min_limit when balance data is received
      if (this.sender_bank && this.sender_bank.includes(' - ')) {
        var payment_mode = this.sender_bank.split(' - ')[1].trim();
        if (payment_mode === data.pg) {
          this.minLimit = data.min_limit;
        }
      }
    },
    handleMinLimitChanged: function(data) {
      // Update min_limit when selection changes
      this.minLimit = data.min_limit;
    },
  }
};
</script>
